import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { CreateProductInformationDefaultCategoryFragmentDoc } from './CreateProductInformationDefaultCategory.generated'
import { ProductSellPackProductFragmentDoc } from './ProductSellPackProduct.generated'
import { ProductUnitSizeProductFragmentDoc } from './ProductUnitSizeProduct.generated'
import * as Types from './purchasePlus_graphql'

export const GetCreateProductModalDocument = gql`
  query GetCreateProductModal($id: Int!) {
    product(id: $id) {
      id
      image
      ...ProductUnitSizeProduct
      ...ProductSellPackProduct
      itemSize
      itemMeasure
      itemPackName
      itemSellPackName
      itemSellQuantity
      brand
      itemDescription
      productCode
      category {
        id
        ...CreateProductInformationDefaultCategory
      }
    }
  }
  ${ProductUnitSizeProductFragmentDoc}
  ${ProductSellPackProductFragmentDoc}
  ${CreateProductInformationDefaultCategoryFragmentDoc}
` as unknown as DocumentNode<Types.GetCreateProductModalQuery, Types.GetCreateProductModalQueryVariables>
